import React, { useContext } from 'react';
import ReactDOM from 'react-dom';

//component
import WorkspaceUserGroupsScreen from  '@/components/page/OrgSettings/Workspaces/UserGroupsTab/WorkspaceUserGroupsScreen';

//context
import { OrgSettingsContext } from '@/context/OrgSettings';



const UserGroupsPortal = () => {    
    const {setAppId, setWorkspaceName, setOrgId } = useContext(OrgSettingsContext);

    const targetContainer = document.getElementById('react-workspace-user-groups-container');
    
    if (!targetContainer) {
        return null;
    } else {
      setAppId(targetContainer?.getAttribute?.('data-app-id'));
      setWorkspaceName(targetContainer?.getAttribute?.('data-app-name'));
      setOrgId(targetContainer?.getAttribute?.('data-org-id'))
    }

    return ReactDOM.createPortal(
      <WorkspaceUserGroupsScreen />, targetContainer
    );
}


export default UserGroupsPortal;